import React, { createContext, useContext, useState } from 'react';

import { track } from '../lib/analytics/gtm';

interface ApplyModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const ApplyModalContext = createContext<ApplyModalContextType | undefined>(undefined);

export const ApplyModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Single choke point for every "Apply Now" surface — the one place the
  // apply_modal_open event fires (opt-out-aware + allowlisted inside track).
  const openModal = async () => {
    if (import.meta.env.DEV || import.meta.env.VITE_RATE_EXPERIENCE_DEMO === 'true' || import.meta.env.VITE_RATE_EXPERIENCE_PUBLIC === 'true') {
      const { openRememberedOfficerApplication } = await import('../features/rate-experience/rememberedOfficerApplication');
      if (await openRememberedOfficerApplication()) return;
    }
    setIsOpen(true);
    track('apply_modal_open');
  };
  const closeModal = () => setIsOpen(false);

  return (
    <ApplyModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </ApplyModalContext.Provider>
  );
};

export const useApplyModal = () => {
  const context = useContext(ApplyModalContext);
  if (context === undefined) {
    throw new Error('useApplyModal must be used within an ApplyModalProvider');
  }
  return context;
};